import createIcon from '../../createIcon';

/**
 * @component @name Face6
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE3LjUyIDIyIDIyIDE3LjUyIDIyIDEyQzIyIDYuNDggMTcuNTIgMiAxMiAyWk0xMiAyMEM3LjU5IDIwIDQgMTYuNDEgNCAxMkM0IDExLjk5IDQgMTEuOTggNCAxMS45N0M2LjMxIDExLjc1IDcuNDMgMTAuMzggOC4zNCA4LjU2QzguNTEgOC4yMSA4Ljg1IDggOS4yNCA4SDE0Ljc3QzE1LjE1IDggMTUuNDkgOC4yMSAxNS42NiA4LjU1QzE2LjU2IDEwLjM1IDE3LjY1IDExLjc0IDIwIDExLjk2QzIwIDExLjk3IDIwIDExLjk4IDIwIDExLjk5QzIwIDE2LjQxIDE2LjQxIDIwIDEyIDIwWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTkgMTQuMjVDOS42OTAzNiAxNC4yNSAxMC4yNSAxMy42OTA0IDEwLjI1IDEzQzEwLjI1IDEyLjMwOTYgOS42OTAzNiAxMS43NSA5IDExLjc1QzguMzA5NjQgMTEuNzUgNy43NSAxMi4zMDk2IDcuNzUgMTNDNy43NSAxMy42OTA0IDguMzA5NjQgMTQuMjUgOSAxNC4yNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNSAxNC4yNUMxNS42OTA0IDE0LjI1IDE2LjI1IDEzLjY5MDQgMTYuMjUgMTNDMTYuMjUgMTIuMzA5NiAxNS42OTA0IDExLjc1IDE1IDExLjc1QzE0LjMwOTYgMTEuNzUgMTMuNzUgMTIuMzA5NiAxMy43NSAxM0MxMy43NSAxMy42OTA0IDE0LjMwOTYgMTQuMjUgMTUgMTQuMjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Face6 = createIcon('Face6', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 11.99 4 11.98 4 11.97C6.31 11.75 7.43 10.38 8.34 8.56C8.51 8.21 8.85 8 9.24 8H14.77C15.15 8 15.49 8.21 15.66 8.55C16.56 10.35 17.65 11.74 20 11.96C20 11.97 20 11.98 20 11.99C20 16.41 16.41 20 12 20Z',
      key: '11uppc',
    },
  ],
  [
    'path',
    {
      d: 'M9 14.25C9.69036 14.25 10.25 13.6904 10.25 13C10.25 12.3096 9.69036 11.75 9 11.75C8.30964 11.75 7.75 12.3096 7.75 13C7.75 13.6904 8.30964 14.25 9 14.25Z',
      key: '1stqvt',
    },
  ],
  [
    'path',
    {
      d: 'M15 14.25C15.6904 14.25 16.25 13.6904 16.25 13C16.25 12.3096 15.6904 11.75 15 11.75C14.3096 11.75 13.75 12.3096 13.75 13C13.75 13.6904 14.3096 14.25 15 14.25Z',
      key: 'ejdty3',
    },
  ],
]);

export default Face6;
